/** Порівняння наборів ID без урахування порядку. */
export const isSameIdSet = (a?: number[] | null, b?: number[] | null): boolean => {
    const left = a || [];
    const right = b || [];
    if (left.length !== right.length) return false;
    const set = new Set(left);
    return right.every((id) => set.has(id));
};
